import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { SavedGroceryInput } from '@/models/grocery';

export const createSavedGrocery = async (data: SavedGroceryInput): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation createSavedGrocery($data: SavedGroceryInputType!) {
        createSavedGrocery(data: $data) {
          id
        }
      }
    `),
    variables: {
      data,
    },
  });

  return !!response.data?.createSavedGrocery;
};
